import AsyncStorage from "@react-native-async-storage/async-storage"

const ICHIOSHI_URL_KEY = "ichioshiUrl"
const EXPIRATION_DAYS = 30
const EXPIRATION_MS = EXPIRATION_DAYS * 24 * 60 * 60 * 1000 // 30日をミリ秒に変換

interface IchioshiData {
  url: string
  savedAt: string
}

export const getIchioshiUrl = async (): Promise<string | null> => {
  try {
    const dataStr = await AsyncStorage.getItem(ICHIOSHI_URL_KEY)
    if (!dataStr) return null

    let data: IchioshiData
    try {
      data = JSON.parse(dataStr)
    } catch {
      await clearIchioshiUrl()
      return null
    }

    // 有効期限チェック
    const savedAt = new Date(data.savedAt)
    const now = new Date()
    const elapsed = now.getTime() - savedAt.getTime()

    if (elapsed > EXPIRATION_MS) {
      // 30日経過していたら削除
      await clearIchioshiUrl()
      return null
    }

    return data.url
  } catch (error) {
    console.error("Failed to get Ichioshi URL:", error)
    return null
  }
}

export const setIchioshiUrl = async (url: string): Promise<void> => {
  try {
    const data: IchioshiData = {
      url,
      savedAt: new Date().toISOString(),
    }
    await AsyncStorage.setItem(ICHIOSHI_URL_KEY, JSON.stringify(data))
  } catch (error) {
    console.error("Failed to save Ichioshi URL:", error)
  }
}

export const clearIchioshiUrl = async (): Promise<void> => {
  try {
    await AsyncStorage.removeItem(ICHIOSHI_URL_KEY)
  } catch (error) {
    console.error("Failed to clear Ichioshi URL:", error)
  }
}
